import { cleanFile } from "./cleanFile";
import { api } from "../api";
import { handleUpdateCardComponent } from "../externalComponents/handleUpdateCardComponent";
import { handleMessageChange } from "../externalComponents/handleMessageChange";
import { message } from "antd";
import { handleMessageMultipleChanges } from "../externalComponents/handleMessageMultipleChanges";
export const handleUploadFile = async ({
  file,
  setIsUploading,
  user,
  selectedNode,
  nodes,
  setHeaderImageLink,
  setHeaderVideoLink,
  setNodes,
  setCards,
  setModifications,
  carouselCardIndex,
  carouselComponentIndex,
  selectedHeader,
  isInPanel,
}) => {
  setIsUploading(true);

  try {
    let response;

    response = await api.media.create({
      customer: { _link: user.customerId },
      file: { file: cleanFile(file) },
      type: selectedHeader.toLowerCase(),
    });

    if (selectedNode.type === "message") {
      handleMessageMultipleChanges(
        { [selectedHeader.toLowerCase()]: response?.file?.url },
        nodes,
        setNodes,
      );
    } else if (selectedNode.data.cards) {
      const newValue = response?.file?.url;
      handleUpdateCardComponent(
        selectedNode,
        carouselCardIndex,
        carouselComponentIndex,
        { link: newValue },
        nodes,
        setNodes,
        setCards,
      );
    } else {
      if (selectedNode.data.isEditing) {
        if (selectedHeader.toLowerCase() === "image") {
          setHeaderImageLink(response?.file?.url);
        } else if (selectedHeader.toLowerCase() === "video") {
          setHeaderVideoLink(response?.file?.url);
        }
        handleMessageChange(
          selectedHeader.toLowerCase(),
          response?.file?.url,
          nodes,
          setNodes,
          selectedNode,
        );
      }
      handleMessageChange(
        selectedHeader.toLowerCase(),
        response?.file?.url,
        nodes,
        setNodes,
        selectedNode,
      );
      handleMessageChange(
        "headerParameters",
        {
          type: selectedHeader.toLowerCase(),
          [selectedHeader.toLowerCase()]: {
            link: response?.file?.url,
          },
        },
        nodes,
        setNodes,
        selectedNode,
      );

      if (isInPanel) {
        handleMessageChange(
          "video",
          response?.file?.url,
          nodes,
          setNodes,
          selectedNode,
        );
        handleMessageChange(
          "headerParameters",
          {
            type: "video",
            video: {
              link: response?.file?.url,
            },
          },
          nodes,
          setNodes,
          selectedNode,
        );
      }
    }
    message.success(`${file.name} successfully imported`);
    setIsUploading(false);
    setModifications(true);
    return true;
  } catch (error) {
    console.log(error);
    throw error;
  } finally {
    setIsUploading(false);
  }
};
